import { Download } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import { Box } from "@mui/system";
import { isEmpty } from "lodash";
import { FC, useEffect, useMemo, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getConfigs } from "../../configs";
import { axiosInstance } from "../../services/axios";

const DownloadList: FC<RouteComponentProps> = () => {
  const [release, setRelease] = useState("");
  const [files, setFiles] = useState<any>({});

  const fetchFiles = async () => {
    try {
      const response = await axiosInstance.get(`${getConfigs().baseApiUrl}/sift/downloads/index.json`);
      const newFiles = response?.data;
      const releaseVersion = newFiles.filter((file: any) => !!file?.version)[0].version;  
      setRelease(releaseVersion);
      setFiles(newFiles);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
      fetchFiles();
  }, []);

  return (
    <Box>
      <Typography variant="h2">SIFT</Typography>
      <Typography variant="h5">Aptori's cross-platform CLI tool</Typography>
      {release && (
        <Typography variant="body1">
          Latest release {release}
        </Typography>
      )}

      

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1em",
          mt: "1em",
        }}
      >
        {isEmpty(files) && (
          <Box>
            <CircularProgress disableShrink />
          </Box>
        )}
        {files.length && files?.map((file: any) => (
          <Box key = {file.fileKey}>
            <Button variant="outlined">
                <FileDownload
                  file={file}
                />
            </Button>
          </Box>
        ))}
        {/**
         * Two columns in one row with a title and description
         */}
        <Box>
          <Grid container sx={{ mx: "auto", mt: 4 }} md={10} item columnSpacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5">What is SIFT?</Typography>
              <Typography variant="body1">
              Sift is a cross-platform CLI tool for stateful intelligent fuzz testing. Sift runs in your CI pipeline or the development environment of your choice (Mac, Linux, Windows) to autonomously analyze an API for defects.

              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h5">
                API Testing with SIFT
              </Typography>
              <Typography variant="body1">
              Given an API definition and URL, sift autonomously generates and executes requests to an API to discover security and functional faults. Sift leverages a semantic graph to ensure the tests are effective, extensive, and efficient.


              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

const FileDownload: React.FC<any> = ({
  file,
  highlighted = false,
}) => {
  return (
    <Box
      onClick={() => {
        window.open(`${getConfigs().baseApiUrl}/sift/downloads/${file.fileKey}`, "_self");
      }}
      sx={{ minWidth: highlighted ? "15em" : "5em" }}
    >
      {highlighted && (
        <Typography variant="h6" sx={{ mt: 1 }}>
          Download SIFT
        </Typography>
      )}
      <IconButton disableRipple>
        <Download sx={{ color: highlighted ? "white" : "primary.main" }} />
      </IconButton>
      <Typography variant="body2" sx={{display: "inline"}}>{file?.fileKey}</Typography>
    </Box>
  );
};

export default withRouter(DownloadList);
